import React from 'react';
import { Box, Card, CardBody, Heading, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, VStack } from '@chakra-ui/react';

const MostPurchasedItemsCard = ({
  mostPurchasedItemsLoading,
  mostPurchasedItems,
  surfaceCard,
  DASHBOARD_TYPE,
  formatCurrency,
  formatNumber,
  handleShowProductDetail,
}) => (
  <Card {...surfaceCard} h="100%">
    <CardBody>
      <Heading fontSize={DASHBOARD_TYPE.chartTableTitle} fontWeight="600" mb={4} color="rgba(0, 0, 0, 0.78)" borderBottom="1px solid rgba(0,0,0,0.08)" pb={2}>
        Most Purchased Items
      </Heading>
      {mostPurchasedItemsLoading ? (
        <Box textAlign="center" py={8}><Spinner /></Box>
      ) : mostPurchasedItems && mostPurchasedItems.length > 0 ? (
        <TableContainer maxH="420px" overflowY="auto" borderRadius="12px" border="1px solid rgba(15,23,42,0.08)">
          <Table size="sm" variant="simple">
            <Thead position="sticky" top={0} bg="#F8FAFC" zIndex={1}>
              <Tr>
                <Th w="50px" fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase">Rank</Th>
                <Th minW="200px" fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase">Product</Th>
                <Th isNumeric w="80px" fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase">Qty</Th>
                <Th isNumeric w="120px" fontSize={DASHBOARD_TYPE.tableHeader} letterSpacing="0.08em" textTransform="uppercase">Revenue</Th>
              </Tr>
            </Thead>
            <Tbody>
              {mostPurchasedItems.map((item) => (
                <Tr key={item.rank} _hover={{ bg: 'rgba(88,86,214,0.06)' }}>
                  <Td fontWeight="bold" color="blue.600" fontSize={DASHBOARD_TYPE.dataLabel} whiteSpace="nowrap">#{item.rank}</Td>
                  <Td maxW="250px">
                    <VStack align="start" spacing={1}>
                      <Text
                        fontSize={DASHBOARD_TYPE.dataLabel}
                        fontWeight="semibold"
                        wordBreak="break-word"
                        whiteSpace="normal"
                        lineHeight="1.4"
                        as="button"
                        color="purple.600"
                        _hover={{ textDecoration: 'underline', color: 'purple.700' }}
                        onClick={() => handleShowProductDetail(item.productName, item.productCode)}
                        cursor="pointer"
                        textAlign="left"
                      >
                        {item.productName}
                      </Text>
                      <Text fontSize={DASHBOARD_TYPE.dataLabel} color="gray.500" wordBreak="break-word" whiteSpace="normal">
                        {item.productCode}
                      </Text>
                    </VStack>
                  </Td>
                  <Td isNumeric fontWeight="semibold" color="purple.600" fontSize={DASHBOARD_TYPE.dataLabel} whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatNumber(item.totalQuantity)}
                  </Td>
                  <Td isNumeric fontWeight="semibold" color="green.600" fontSize={DASHBOARD_TYPE.dataLabel} whiteSpace="nowrap" sx={{ fontVariantNumeric: 'tabular-nums' }}>
                    {formatCurrency(item.totalRevenue)}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Text color="gray.500" textAlign="center" py={8}>No data available</Text>
      )}
    </CardBody>
  </Card>
);

export default MostPurchasedItemsCard;
